import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodemagicComponent } from './simple-icons-codemagic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodemagicComponent ],
    exports:      [ SimpleIconsCodemagicComponent ],
    bootstrap:    []
})
export class SimpleIconsCodemagicModule {}
